<div class="login">
  <div class="login__leftPane"></div>
  <div class="login__rightPane">
    <div class="login__rightPane--header">
      <span (click)="goBack()" class="item-icon circle">
        <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.2349 0.764455C19.1189 0.648349 18.9813 0.556237 18.8297 0.49339C18.6782 0.430542 18.5157 0.398193 18.3517 0.398193C18.1876 0.398193 18.0251 0.430542 17.8736 0.49339C17.722 0.556237 17.5844 0.648349 17.4685 0.764455L9.99965 8.23325L2.55006 0.764455C2.43414 0.648349 2.29647 0.556237 2.14492 0.49339C1.99337 0.430542 1.83092 0.398193 1.66686 0.398193C1.50279 0.398193 1.34034 0.430542 1.18879 0.49339C1.03724 0.556237 0.89957 0.648349 0.783655 0.764455C0.667549 0.88037 0.575437 1.01804 0.51259 1.16959C0.449742 1.32114 0.417393 1.48359 0.417393 1.64766C0.417393 1.81172 0.449742 1.97417 0.51259 2.12572C0.575437 2.27727 0.667549 2.41494 0.783655 2.53086L8.23325 9.99965L0.764455 17.4493C0.648349 17.5652 0.556237 17.7028 0.49339 17.8544C0.430542 18.0059 0.398193 18.1684 0.398193 18.3325C0.398193 18.4965 0.430542 18.659 0.49339 18.8105C0.556237 18.9621 0.648349 19.0997 0.764455 19.2157C0.88037 19.3318 1.01804 19.4239 1.16959 19.4867C1.32114 19.5496 1.48359 19.5819 1.64766 19.5819C1.81172 19.5819 1.97417 19.5496 2.12572 19.4867C2.27727 19.4239 2.41494 19.3318 2.53086 19.2157L9.99965 11.7661L17.4493 19.2349C17.5652 19.351 17.7028 19.4431 17.8544 19.5059C18.0059 19.5688 18.1684 19.6011 18.3325 19.6011C18.4965 19.6011 18.659 19.5688 18.8105 19.5059C18.9621 19.4431 19.0997 19.351 19.2157 19.2349C19.3318 19.1189 19.4239 18.9813 19.4867 18.8297C19.5496 18.6782 19.5819 18.5157 19.5819 18.3517C19.5819 18.1876 19.5496 18.0251 19.4867 17.8736C19.4239 17.722 19.3318 17.5844 19.2157 17.4685L11.7661 9.99965L19.2349 2.55006C19.3539 2.43381 19.4484 2.29495 19.513 2.14162C19.5776 1.9883 19.6108 1.82362 19.6108 1.65726C19.6108 1.49089 19.5776 1.32621 19.513 1.17289C19.4484 1.01956 19.3539 0.880699 19.2349 0.764455Z"
            fill="#959595" opacity="0.5" />
        </svg>
      </span>
    </div>
    <div class="login__content">
      <h4 class="login__header">
        {{ role === "Litigant" ? "Litigant / Counsel" : role }} Sign up
      </h4>
      <div class="login__help">
        Already have an account?
        <span>
          <a *ngIf="role != 'Litigant'" [queryParams]="{ id: 'Registrar' }" class="login__help--link"
            routerLink="/login">Login
          </a>
        </span>
        <span>
          <a *ngIf="role == 'Litigant'" [queryParams]="{ id: 'Litigant' }" class="login__help--link"
            routerLink="/login">Login
          </a>
        </span>
        <span>
          <a *ngIf="role == 'Official'" [queryParams]="{ id: 'Official' }" class="login__help--link"
            routerLink="/login">Login
          </a>
        </span>
      </div>
      <div *ngIf="showError" class="error_message">
        <p class="text_error">{{ error }}</p>
      </div>
      <form (ngSubmit)="registratrar(registrarForm)" [formGroup]="registrarForm" id="regForm" autocomplete="off">
        <div class="u-grid-column-2">
          <div class="form-group">
            <label class="label" for="firstname">First Name</label>
            <input aria-describedby="emailHelp" class="form-control" formControlName="firstname" id="firstname"
              placeholder="E.g Timi" type="email" autocomplete="none" />
          </div>
          <div class="form-group">
            <label class="label" for="lastname">Last Name</label>
            <input aria-describedby="emailHelp" class="form-control" formControlName="lastname" id="lastname"
              placeholder="E.g Eze" type="email" autocomplete="none" />
          </div>
        </div>
        <div class="form-group">
          <label class="label" for="official">OFFICIAL Email Address</label>
          <input class="form-control" formControlName="official" placeholder="E.g timiofficial@gmail.com" type="email"
            [class.disabled_]="role == 'Registrar'" />
        </div>
        <div class="form-group">
          <label class="label" for="personal">PERSONAL Email Address <span>(Optional)</span></label>
          <input class="form-control" formControlName="personal" placeholder="E.g timi@gmail.com" type="email"
            autocomplete="none" />
        </div>
        <div class="form-group">
          <label class="label" for="phone">Phone Number </label>
          <div class="input__appendContainer">
            <input class="form-control phone__number" [class.disabled_]="role == 'Registrar'"
              formControlName="phoneNumber" id="phone" placeholder="Enter phone number" [disabled]="role == 'Registrar'"
              type="tel" />
            <span class="input__prepend">
              <svg fill="none" height="13" viewBox="0 0 48 13" width="48" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.58008 5.66113H7.35547V6.85742H4.58008V10.002H3.30859V6.85742H0.533203V5.66113H3.30859V2.75586H4.58008V5.66113ZM18.7646 11H12.2432V10.0908L15.6885 6.2627C16.1989 5.68392 16.5498 5.21452 16.7412 4.85449C16.9372 4.48991 17.0352 4.11393 17.0352 3.72656C17.0352 3.20703 16.8779 2.78092 16.5635 2.44824C16.249 2.11556 15.8298 1.94922 15.3057 1.94922C14.6768 1.94922 14.1868 2.12923 13.8359 2.48926C13.4896 2.84473 13.3164 3.34147 13.3164 3.97949H12.0518C12.0518 3.06348 12.3457 2.32292 12.9336 1.75781C13.526 1.19271 14.3167 0.910156 15.3057 0.910156C16.2308 0.910156 16.9622 1.15397 17.5 1.6416C18.0378 2.12467 18.3066 2.76953 18.3066 3.57617C18.3066 4.55599 17.6823 5.72266 16.4336 7.07617L13.7676 9.96777H18.7646V11ZM21.9434 5.4082H22.8936C23.4906 5.39909 23.96 5.24186 24.3018 4.93652C24.6436 4.63118 24.8145 4.21875 24.8145 3.69922C24.8145 2.53255 24.2334 1.94922 23.0713 1.94922C22.5244 1.94922 22.0869 2.10645 21.7588 2.4209C21.4352 2.73079 21.2734 3.14323 21.2734 3.6582H20.0088C20.0088 2.86979 20.2959 2.21582 20.8701 1.69629C21.4489 1.1722 22.1826 0.910156 23.0713 0.910156C24.0101 0.910156 24.7461 1.15853 25.2793 1.65527C25.8125 2.15202 26.0791 2.84245 26.0791 3.72656C26.0791 4.15951 25.9378 4.57878 25.6553 4.98438C25.3773 5.38997 24.9967 5.69303 24.5137 5.89355C25.0605 6.06673 25.4821 6.35384 25.7783 6.75488C26.0791 7.15592 26.2295 7.64583 26.2295 8.22461C26.2295 9.11784 25.9378 9.8265 25.3545 10.3506C24.7712 10.8747 24.0124 11.1367 23.0781 11.1367C22.1439 11.1367 21.3828 10.8838 20.7949 10.3779C20.2116 9.87207 19.9199 9.20443 19.9199 8.375H21.1914C21.1914 8.89909 21.3623 9.31836 21.7041 9.63281C22.0459 9.94727 22.5039 10.1045 23.0781 10.1045C23.6888 10.1045 24.1559 9.94499 24.4795 9.62598C24.8031 9.30697 24.9648 8.84896 24.9648 8.25195C24.9648 7.67318 24.7871 7.22884 24.4316 6.91895C24.0762 6.60905 23.5635 6.44954 22.8936 6.44043H21.9434V5.4082ZM33.3047 7.65723H34.6855V8.68945H33.3047V11H32.0332V8.68945H27.501V7.94434L31.958 1.04688H33.3047V7.65723ZM28.9365 7.65723H32.0332V2.77637L31.8828 3.0498L28.9365 7.65723ZM47.6328 12.8457H46.6143V1.04688H47.6328V12.8457Z"
                  fill="#353535" />
              </svg>
            </span>
          </div>

          <div *ngIf="
              phoneNumber.invalid &&
              phoneNumber.dirty &&
              phoneNumber.errors?.isLessThanMin
            " class="help-block text-error">
            ({{ phoneNumber.errors.isLessThanMin }}: can't start with zero )
          </div>
          <div *ngIf="phoneNumber.errors?.required && phoneNumber.dirty" class="help-block text-error">
            Phone Number is Required
          </div>
          <div *ngIf="phoneNumber.errors?.minlength && phoneNumber.dirty" class="help-block text-error">
            Below minimum length (10)
          </div>
          <div *ngIf="phoneNumber.errors?.maxlength && phoneNumber.dirty" class="help-block text-error">
            Above maximum length (10)
          </div>
        </div>

        <div class="form-group" *ngIf="role == 'Litigant'">
          <label class="label" for="username">State</label>
          <div class="input__appendContainer">
            <select class="form-control" formControlName="stateId">
              <option value="">-Select State-</option>
              <option *ngFor="let state of stateData" [value]="state.id">{{
                state?.name
                }}</option>
            </select>
          </div>
        </div>

        <div class="form-group" *ngIf="role == 'Litigant'">
          <label class="label caps_upper" for="">Supreme Court Enrollment Number</label>
          <input class="form-control" formControlName="enrollmentId" placeholder="Supreme Court Enrollment Number"
            type="text" autocomplete="none" />
        </div>

        <div class="form-group">
          <label class="label" for="exampleInputPassword1">Password</label>
          <div class="input__appendContainer">
            <generic-password-control PasswordPlaceholder="Enter your password"
              (EmitPassword)="setGenericPassword($event)" [showInputValidators]="true">
            </generic-password-control>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label caps_upper" for="">Confirm Password</label>
          <generic-password-control PasswordPlaceholder="Re-enter your password"
            (EmitPassword)="setGenericConfirmPasswordPassword($event)" [showInputValidators]="false">
          </generic-password-control>
          <p *ngIf="password.value !== confirmPassword.value" class="help-block text-error">
            Confirm Password
          </p>
        </div>
        <div class="form-group form__t_c">
          <input placeholder="Password" type="checkbox" (change)="toggleTermsAndCondition()" />
          <label class="control-label caps_upper" for="">I have read and agreed to the
            <a href="#terms___" data-toggle="modal">terms of service</a></label>
        </div>
        <button (click)="registratrar(registrarForm)" [disabled]="registrarForm.invalid || !acceptTermsAndCondtion"
          class="btn__primary" form="registrarForm" type="submit" [class.loading]="btnSpinner">
          <div class="loader_item">
            <div class="cm_spinner"></div>
          </div>
          <span [class.invisible]="btnSpinner">Create account</span>
        </button>
      </form>
    </div>
  </div>
</div>
